import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SimilarTitleFragmentDoc } from '../../../components/graphql/queries/GetSimilarTitles.query';
export type TitleDetailModules_Movie_Fragment = {
	__typename?: 'Movie';
	titleModules: Array<{
		__typename?: 'Module';
		fomoScore: number;
		content?:
			| { __typename?: 'ModuleContentSQTV' }
			| { __typename?: 'ModuleContentSports' }
			| {
					__typename?: 'ModuleContentStreamingCharts';
					Titles: Array<{
						__typename?: 'ModuleStreamingChartEdges';
						fullPath: string;
						jwEntityID: string;
						posterUrl: string;
						title: string;
						showTitle?: string | null;
						seasonNumber?: number | null;
						rankInfo: {
							__typename?: 'StreamingChartInfo';
							rank: number;
							trend: Types.ModuleContentTitleTrend;
							trendDifference: number;
							updatedAt?: any | null;
							daysInTop10: number;
							daysInTop100: number;
							daysInTop1000: number;
							daysInTop3: number;
							topRank: number;
						};
					}>;
			  }
			| { __typename?: 'ModuleContentTextRecommendation' }
			| { __typename?: 'ModuleContentTextRecommendations' }
			| {
					__typename?: 'ModuleContentTitles';
					titles: Array<{
						__typename?: 'ModuleContentTitleEdge';
						node:
							| {
									__typename: 'Movie';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									content: {
										__typename?: 'MovieContent';
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										genres: Array<{ __typename?: 'Genre'; translation: string }>;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
									};
							  }
							| {
									__typename: 'Season';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									content: {
										__typename?: 'SeasonContent';
										seasonNumber: number;
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										genres: Array<{ __typename?: 'Genre'; translation: string }>;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
									};
									show: {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: { __typename?: 'ShowContent'; title: string };
									};
							  }
							| {
									__typename: 'Show';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									seenState: {
										__typename?: 'ShowSeenState';
										progress: number;
										seenEpisodeCount: number;
									};
									content: {
										__typename?: 'ShowContent';
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										genres: Array<{ __typename?: 'Genre'; translation: string }>;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
									};
							  };
					}>;
			  }
			| { __typename?: 'ModuleContentTitlesArticle' }
			| { __typename?: 'ModuleContentTitlesPerPackage' }
			| { __typename?: 'ModuleContentTitlesRelatedToTitle' }
			| { __typename?: 'ModuleContentVODTitles' }
			| null;
		template: {
			__typename?: 'ModuleTemplate';
			anchor?: string | null;
			contentType: Types.ModuleContentType;
			technicalName: string;
		};
	} | null>;
};

export type TitleDetailModules_Season_Fragment = {
	__typename?: 'Season';
	titleModules: Array<{
		__typename?: 'Module';
		fomoScore: number;
		content?:
			| { __typename?: 'ModuleContentSQTV' }
			| { __typename?: 'ModuleContentSports' }
			| {
					__typename?: 'ModuleContentStreamingCharts';
					Titles: Array<{
						__typename?: 'ModuleStreamingChartEdges';
						fullPath: string;
						jwEntityID: string;
						posterUrl: string;
						title: string;
						showTitle?: string | null;
						seasonNumber?: number | null;
						rankInfo: {
							__typename?: 'StreamingChartInfo';
							rank: number;
							trend: Types.ModuleContentTitleTrend;
							trendDifference: number;
							updatedAt?: any | null;
							daysInTop10: number;
							daysInTop100: number;
							daysInTop1000: number;
							daysInTop3: number;
							topRank: number;
						};
					}>;
			  }
			| { __typename?: 'ModuleContentTextRecommendation' }
			| { __typename?: 'ModuleContentTextRecommendations' }
			| {
					__typename?: 'ModuleContentTitles';
					titles: Array<{
						__typename?: 'ModuleContentTitleEdge';
						node:
							| {
									__typename: 'Movie';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									content: {
										__typename?: 'MovieContent';
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										genres: Array<{ __typename?: 'Genre'; translation: string }>;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
									};
							  }
							| {
									__typename: 'Season';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									content: {
										__typename?: 'SeasonContent';
										seasonNumber: number;
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										genres: Array<{ __typename?: 'Genre'; translation: string }>;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
									};
									show: {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: { __typename?: 'ShowContent'; title: string };
									};
							  }
							| {
									__typename: 'Show';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									seenState: {
										__typename?: 'ShowSeenState';
										progress: number;
										seenEpisodeCount: number;
									};
									content: {
										__typename?: 'ShowContent';
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										genres: Array<{ __typename?: 'Genre'; translation: string }>;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
									};
							  };
					}>;
			  }
			| { __typename?: 'ModuleContentTitlesArticle' }
			| { __typename?: 'ModuleContentTitlesPerPackage' }
			| { __typename?: 'ModuleContentTitlesRelatedToTitle' }
			| { __typename?: 'ModuleContentVODTitles' }
			| null;
		template: {
			__typename?: 'ModuleTemplate';
			anchor?: string | null;
			contentType: Types.ModuleContentType;
			technicalName: string;
		};
	} | null>;
};

export type TitleDetailModules_Show_Fragment = {
	__typename?: 'Show';
	titleModules: Array<{
		__typename?: 'Module';
		fomoScore: number;
		content?:
			| { __typename?: 'ModuleContentSQTV' }
			| { __typename?: 'ModuleContentSports' }
			| {
					__typename?: 'ModuleContentStreamingCharts';
					Titles: Array<{
						__typename?: 'ModuleStreamingChartEdges';
						fullPath: string;
						jwEntityID: string;
						posterUrl: string;
						title: string;
						showTitle?: string | null;
						seasonNumber?: number | null;
						rankInfo: {
							__typename?: 'StreamingChartInfo';
							rank: number;
							trend: Types.ModuleContentTitleTrend;
							trendDifference: number;
							updatedAt?: any | null;
							daysInTop10: number;
							daysInTop100: number;
							daysInTop1000: number;
							daysInTop3: number;
							topRank: number;
						};
					}>;
			  }
			| { __typename?: 'ModuleContentTextRecommendation' }
			| { __typename?: 'ModuleContentTextRecommendations' }
			| {
					__typename?: 'ModuleContentTitles';
					titles: Array<{
						__typename?: 'ModuleContentTitleEdge';
						node:
							| {
									__typename: 'Movie';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									content: {
										__typename?: 'MovieContent';
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										genres: Array<{ __typename?: 'Genre'; translation: string }>;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
									};
							  }
							| {
									__typename: 'Season';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									content: {
										__typename?: 'SeasonContent';
										seasonNumber: number;
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										genres: Array<{ __typename?: 'Genre'; translation: string }>;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
									};
									show: {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: { __typename?: 'ShowContent'; title: string };
									};
							  }
							| {
									__typename: 'Show';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									seenState: {
										__typename?: 'ShowSeenState';
										progress: number;
										seenEpisodeCount: number;
									};
									content: {
										__typename?: 'ShowContent';
										title: string;
										posterUrl?: string | null;
										fullPath: string;
										genres: Array<{ __typename?: 'Genre'; translation: string }>;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: {
											__typename?: 'Scoring';
											imdbVotes?: number | null;
											imdbScore?: number | null;
											tomatoMeter?: number | null;
											certifiedFresh?: boolean | null;
											jwRating?: number | null;
										};
										interactions: { __typename?: 'InteractionAttributes'; votesNumber: number };
									};
							  };
					}>;
			  }
			| { __typename?: 'ModuleContentTitlesArticle' }
			| { __typename?: 'ModuleContentTitlesPerPackage' }
			| { __typename?: 'ModuleContentTitlesRelatedToTitle' }
			| { __typename?: 'ModuleContentVODTitles' }
			| null;
		template: {
			__typename?: 'ModuleTemplate';
			anchor?: string | null;
			contentType: Types.ModuleContentType;
			technicalName: string;
		};
	} | null>;
};

export type TitleDetailModulesFragment =
	| TitleDetailModules_Movie_Fragment
	| TitleDetailModules_Season_Fragment
	| TitleDetailModules_Show_Fragment;

export const TitleDetailModulesFragmentDoc = gql`
	fragment TitleDetailModules on MovieOrShowOrSeason {
		titleModules(supportedContentTypes: []) {
			content {
				... on ModuleContentTitles {
					titles {
						node {
							...SimilarTitle
						}
					}
				}
				... on ModuleContentStreamingCharts {
					Titles {
						fullPath
						jwEntityID
						posterUrl
						title
						showTitle
						seasonNumber
						rankInfo {
							rank
							trend
							trendDifference
							updatedAt
							daysInTop10
							daysInTop100
							daysInTop1000
							daysInTop3
							topRank
						}
					}
				}
			}
			fomoScore
			template {
				anchor
				contentType
				technicalName
			}
		}
	}
	${SimilarTitleFragmentDoc}
`;
